import React from "react";
import {
  FormControlLabel,
  Stack,
  Switch,
  Typography,
  Link,
} from "@mui/material";

export default function StudentInputSettings({
  prefs,
  onChange,
  disabled = false,
}) {
  return (
    <Stack spacing={1} sx={{ my: 2 }}>
      <Typography variant="subtitle1">Student typed answers</Typography>
      {[
        ["allow_spelling_assistance", "Allow spelling assistance"],
        ["allow_copy_paste", "Allow copy and paste"],
      ].map(([key, label]) => (
        <FormControlLabel
          key={key}
          label={label}
          control={
            <Switch
              checked={prefs[key] !== false}
              disabled={disabled}
              onChange={(event) => onChange(key, event.target.checked)}
            />
          }
        />
      ))}
      <Typography variant="body2" color="text.secondary">
        These controls apply to student typing, including shared submission
        links. Browser and device tools may still provide assistance. Image and
        document uploads are unchanged.
      </Typography>
      <Link
        href="/help/tutorials/first-answer#typing-settings"
        target="_blank"
        rel="noopener noreferrer"
      >
        Help with student typing settings
      </Link>
    </Stack>
  );
}
